interface HasID {
  id: number
}

export const haveMatchingIDs = <T extends HasID>(arr1: T[], arr2: T[]): boolean => {
  if (arr1.length !== arr2.length) return false
  const idArr1 = arr1.map((item: T) => item.id).sort()
  const idArr2 = arr2.map((item: T) => item.id).sort()
  for (let i = 0; i < idArr1.length; i++) {
    if (idArr1[i] !== idArr2[i]) {
      return false
    }
  }

  return true
}
